import Svg, { Path } from 'react-native-svg'

const Camera = ({ width = 14, height = 14, color = '#fff' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M10.889 4.222h-.5a.556.556 0 0 1-.467-.26l-.555-.89a1.111 1.111 0 0 0-.945-.516H5.578a1.111 1.111 0 0 0-.94.516l-.555.89a.555.555 0 0 1-.472.26h-.5A1.667 1.667 0 0 0 1.444 5.89v3.889a1.667 1.667 0 0 0 1.667 1.667h7.778a1.667 1.667 0 0 0 1.667-1.667V5.889a1.667 1.667 0 0 0-1.667-1.667ZM7 9.222A1.667 1.667 0 1 1 7 5.89a1.667 1.667 0 0 1 0 3.333Z"
    />
  </Svg>
)
export default Camera
